import { Link, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { InviteForm } from '@/components/team/invite-form';

export function TeamInvitePage() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/team" className="text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-5 w-5" />
        </Link>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Invite Team Member</h1>
          <p className="text-muted-foreground">Send an invitation to join your team.</p>
        </div>
      </div>

      <InviteForm onSuccess={() => void navigate({ to: '/team' })} />
    </div>
  );
}
